// extracted by mini-css-extract-plugin
export default {"container":"popup__container-x_pPw"};